/**
 * © [2025] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  errorMessagesInRedux: [],
  requestDataNicheReportList: [],
  dataNicheReportScreenObj: {},
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.HANDLE_ERROR_MESSAGE_RDNR:
      return {
        ...state,
        errorMessagesInRedux: action.errorMessagesInRedux,
      };

    case actionTypes.GET_REQUEST_DATA_NICHE_REPORT_LIST:
      return {
        ...state,
        requestDataNicheReportList: action.requestDataNicheReportList,
      };
    case actionTypes.DATA_NICHE_REPORT_SCREEN_TAB_DATA:
      return {
        ...state,
        dataNicheReportScreenObj: action.dataNicheReportScreenObj,
      };

    default:
      return state;
  }
};

export default reducer;
